import React from 'react';
import type { FaqItem } from './faqs';
export const faqsHow: FaqItem[] = [{
  q: 'How is an atom different from a chunk?',
  a: <>
        A chunk is a passage retrieved because it resembles the query &mdash; descriptive, truncated, unversioned. An
        atom is a single binary DO/DON'T with an owner, a version, and a trigger. It fires because it's{' '}
        <strong data-id="element-334" data-mp="1ey5phny72vb5">required</strong>, not because it sounds relevant.
      </>
}, {
  q: 'What actually happens at 80 rules?',
  a: <>
        In controlled tests across five models, the rate of fully-compliant responses fell to zero once a prompt
        carried roughly 80 simultaneous rules &mdash; every model tested (arXiv:2607.19257). IFScale independently
        shows adherence degrading with density and a bias toward whatever came first (arXiv:2507.11538). Synthia seats
        the musts first.
      </>
}, {
  q: 'What about verification loops or self-critique?',
  a: <>
        Self-critique asks the model to grade its own homework with the same attention that missed the instruction the
        first time. Verification has to be a property of the rule. Every atom in your library carries two forms: the
        instruction the model receives before it answers, and the verification question an inspector would ask after.
        Today, the receipt proves the telling: obligations, versions, trigger, signature. The verification form is built
        into the schema by design, ready for the check runtimes now arriving to read it. When we switch that on,
        you&rsquo;ll hear about it.
      </>
}, {
  q: 'Model-agnostic — really?',
  a: <>
        Yes. The obligations are authored once and compiled into whatever payload the target model reads best. No
        single format wins across models, so Synthia compiles per target.
      </>
}, {
  q: 'How do updates and versioning work?',
  a: <>
        Every atom is versioned. When a rule changes, the new version supersedes the old, and the receipt records
        exactly which version fired on which request.
      </>
}, {
  q: 'Where does this sit in my stack?',
  a: <>
        Between intent and inference &mdash; after the prompt is formed, before the model runs. Pre-flight, not
        post-hoc, alongside your existing retrieval, orchestration, and models.
      </>
}, {
  q: 'What can you actually prove in an audit?',
  a: <>
        For any request: which obligations were required, which versions were seated, what triggered them, and when
        &mdash; signed. "We retrieved some relevant passages" is not a defense. A receipt is.
      </>
}];